<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules")
  el-switch(ref="fieldEditor", v-model="fieldModel", v-show="!isReadMode", v-bind="switchBind", @change="handleChangeEvent")
  template(v-if="isReadMode")
    span.readonly-mode-field {{ contentForReadMode }}
</template>
<script>
import { staticMixins, V_FORM_ENUM } from "@/CommonDP/VForm/utils";
import { SWITCH_ENUM } from "./index.js";
export default {
  mixins: [staticMixins],
  computed: {
    valueList() {
      const {
        options: { activeValue }
      } = this;
      return SWITCH_ENUM[activeValue] || SWITCH_ENUM.bool;
    },
    vmDefaultValue() {
      const {
        valueList: [inactiveValue, activeValue],
        options: { defaultValue }
      } = this;
      return defaultValue ? activeValue : inactiveValue;
    },
    switchBind() {
      const {
        valueList: [inactiveValue, activeValue],
        options: { disabled, activeText, inactiveText, activeColor, inactiveColor, switchWidth: width }
      } = this;
      return { activeValue, inactiveValue, disabled, activeText, inactiveText, activeColor, inactiveColor, width };
    },
    // 组件对应上级表单数据
    fieldModel: {
      get() {
        return this.formatValue(this.curFieLdForm[this.field.options.name]);
      },
      set(value) {
        const oldValue = this.fieldModel;
        this.syncUpdateFormModel(value);
        this.emitFieldDataChange(value, oldValue);
        this.withUpdate(value);
      }
    },
    contentForReadMode() {
      const {
        fieldModel,
        options: { activeText, inactiveText },
        valueList: [_inactive, active]
      } = this;
      _inactive; // 防止eslint错误
      const myVal = fieldModel === active;
      if (myVal) {
        return activeText || this.i18nt("render.hint.defaultActiveText");
      } else {
        return inactiveText || this.i18nt("render.hint.defaultInactiveText");
      }
    }
  },
  watch: {
    defaultValue() {
      if (this.vFormMode === V_FORM_ENUM.design) this.fieldModel = this.vmDefaultValue;
    }
  },
  methods: {
    // 防止数据出现不符合格式的bug
    async withUpdate(val) {
      const fVal = this.formatValue(val);
      if (fVal !== val) {
        await this.$nextTick();
        this.fieldModel = fVal;
      }
    },
    // 获取数据是否是当前允许的
    formatValue(value) {
      const isFormat = this.valueList.indexOf(value) !== -1;
      return isFormat ? value : this.vmDefaultValue;
    },
    // 取消 设计状态时修改阻止
    preventDesign() {},
    preventPreview() {},
    // 初始化判断数据
    initFieldModel() {
      const { fieldModel } = this;
      const value = this.formatValue(fieldModel);
      this.fieldModel = value;
    }
  }
};
</script>
